const EmailForHelp = ({ reason = "wrong-info" }) => {
  const wrongInfoMessaging = {
    title: "Does your information not look right?",
    messagePrefix:
      "If the name on the registration form is not correct or you are having any issues logging in, please email us at "
  };

  const loginIssuesMessaging = {
    title: "Let us help.",
    messagePrefix: "If you are still having issues logging in, please email us at "
  };

  const messaging = {
    "wrong-info": wrongInfoMessaging,
    "login-issues": loginIssuesMessaging
  };

  return (
    <div className="views display-grid gap-xl">
      <div className="header">
        <h1 className="serif">
          <strong>{messaging[reason].title}</strong>
        </h1>
      </div>
      <p className="base">
        {messaging[reason].messagePrefix}
        <a className="btn-text-blue" href="mailto:community@worldvision.org" target="_blank">
          community@worldvision.org
        </a>
        , and we can help.
      </p>
    </div>
  );
};

export default EmailForHelp;
